import React, { useState } from 'react'
import { connect } from 'react-redux'

import { setAutomaticUpdate } from '../../actions/appState'
import { getAutomaticallyUpdate, getUpdateAvailable } from '../../selectors/appState'

import ConfirmDialog from '../dialog/ConfirmDialog'
import { ReactComponent as ConfirmVersionUpdateIcon } from '../../assets/icons/yellow-exclamation.svg'
import { refreshCache, morningUpdate } from '../../utils/newAppVersionAvailable'

import styles from './HamburgerMenu.module.scss'

const HamburgerMenu = ({ name, updateAvailable, automaticallyUpdate, setAutomaticUpdate }) => {
  const [showConfirm, setShowConfirm] = useState(false)

  let confirmVersionUpdateComponent
  if (showConfirm) {
    confirmVersionUpdateComponent = (
    <ConfirmDialog
      title="Version update available"
      message={'Warning: Syncing may interrupt current orders in progress'}
      cancelButtonText="Try Later"
      confirmButtonText="Update Now"
      onCancel={() => {
        setShowConfirm(false)
        setAutomaticUpdate()
        morningUpdate()
      }}
      onConfirm={() => {
        refreshCache()
        setAutomaticUpdate()
      }}
    />
    )
  }

  return (
    <div className={styles.hamburgerMenu}>
      {updateAvailable && automaticallyUpdate && <div className={styles.versionUpdateIcon}>
          <ConfirmVersionUpdateIcon onClick={() => setShowConfirm(true)}/>
      </div>}
      <h2 class={styles.name}>{name}</h2>
      {confirmVersionUpdateComponent}
    </div>
  )
}

const mapStateToProps = (state) => {
  const updateAvailable = getUpdateAvailable(state)
  const automaticallyUpdate = getAutomaticallyUpdate(state)
  return { updateAvailable, automaticallyUpdate }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setAutomaticUpdate: () => dispatch(setAutomaticUpdate({ automaticallyUpdate: false }))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HamburgerMenu)
